import * as yup from "yup";
import { NATIONALITY, PAYMENT_METHOD } from "./staticData";

const validationSchema = yup.object().shape({
    nationality: yup.object().shape({
        label: yup
            .string()
            .oneOf(NATIONALITY.map((item) => item?.label))
            .required("Please choose your Nationality"),
        value: yup.string().oneOf(NATIONALITY.map((item) => item?.value)),
    }),
    nationalId: yup.string().required("Please choose your National id"),
    name: yup
        .string()
        .matches(/^[؀-ۿ\s]+$/, "Name must be in Arabic")
        .min(4)
        .required(),
    phoneNumber: yup
        .string()
        .matches(/^01([0-2]|5)[0-9]{8}$/, "Please enter a valid phone number")
        .required(),
    email: yup.string().email(),
    isTruckOwner: yup.boolean().optional(),
    ownerPlateNumber: yup.object().when("isTruckOwner", {
        is: (value) => value === true,
        then: () => yup.object().required("Owner Plate Number is required"),
        otherwise: () => yup.object().optional(),
    }),
    passportNumber: yup.array().when("nationality.label", {
        is: "Egyptian",
        then: () => yup.array().strip(),
        otherwise: () => yup.string().required("please enter your passport number").max(9),
    }),
    idExpiryDate: yup.string().required("please enter a valid date"),
    licenseExpiryDate: yup.string().required(),
    nationalIdFace: yup.array().when("nationality.label", {
        is: "Egyptian",
        then: () => yup.array().required("please enter your id face photo"),
        otherwise: () => yup.array().strip(),
    }),
    nationalIdBack: yup.array().when("nationality.label", {
        is: "Egyptian",
        then: () => yup.array().required("please enter your id back photo"),
        otherwise: () => yup.array().strip(),
    }),
    passport: yup.array().when("nationality.label", {
        is: "Syrian",
        then: () => yup.array().required("please enter your passport photo"),
        otherwise: () => yup.array().strip(),
    }),
    workingGovernorates: yup.array().required("please enter your working governorates"),
    supplier: yup.lazy((value) =>
        // eslint-disable-next-line no-unused-expressions
        Array.isArray(value)
            ? yup.array().required("please enter your suppliers")
            : yup.object().required("please enter your supplier")
    ),
    driverLicense: yup.array().required("please enter your drivind license photo"),
    drivingLicenseType: yup.object().required("Please choose your driver license type"),
    truckTypes: yup.array().required("please enter your preferred truck type"),
    methodType: yup.object().shape({
        label: yup
            .string()
            .oneOf(PAYMENT_METHOD.map((method) => method?.label))
            .optional(),
        value: yup.string().oneOf(PAYMENT_METHOD.map((method) => method?.value)),
    }),
    accountHolderName: yup.object().when("methodType.label", {
        is: (value) => value && value.length > 0,
        then: () => yup.string().required("choose account owner name"),
        otherwise: () => yup.string().strip(),
    }),
    bankName: yup.object().when("methodType.label", {
        is: "Bank Account",
        then: () => yup.object().required("choose banke name"),
        otherwise: () => yup.object().strip(),
    }),
    bankAccountNumber: yup.string().when("methodType.label", {
        is: "Bank Account",
        then: () =>
            yup.string().matches(/^\d{16}$/, "Bank account number must be exactly 16 digits"),
        otherwise: () => yup.string().strip(),
    }),
    bankIban: yup.string().when("methodType.label", {
        is: "Bank Account",
        then: () => yup.string().required("please enter your IBAN number"),
        otherwise: () => yup.string().strip(),
    }),
    eWalletType: yup.object().when("methodType.label", {
        is: "E-Wallet",
        then: () => yup.object().required("shoose your ewallet"),
        otherwise: () => yup.object().strip(),
    }),
    eWalletNumber: yup.string().when("methodType.label", {
        is: "E-Wallet",
        then: () =>
            yup
                .string()
                .matches(/^01([0-2]|5)[0-9]{8}$/, "Please enter a valid phone number")
                .required(),
        otherwise: () => yup.string().strip(),
    }),
    mezzaCardType: yup.object().when("methodType.label", {
        is: "Meeza Card",
        then: () => yup.object().required("choose your bank name"),
        otherwise: () => yup.object().strip(),
    }),
    mezzaCardNumber: yup.string().when("methodType.label", {
        is: "Meeza Card",
        then: () =>
            yup
                .string()
                .matches(/^\d{16}$/, "Mezza Card number must be exactly 16 digits")
                .required(),
        otherwise: () => yup.string().strip(),
    }),
});

export default validationSchema;
